import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import UserWidget from './UserWidget';
import Loader from '../builder/Interface/Loader/Loader';
import { Row, Col, Button } from 'react-bootstrap';
import { Gear } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';
import TopBar from '../builder/Interface/TopBar/TopBar';
import NavList from '../builder/Interface/NavList/NavList';
import { usePageView } from '../../hooks/useAnalytics';
import { WidgetsContext, AppContext, isDemo, AccountContext } from '../../GlobalContex';
import SettingsPanel from '../settings-panel/SettingsPanel';

const Home = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { widgets, activeWidget, loadWidgets, contextWidget } = useContext(WidgetsContext);
  const { isEmbeded, setIsLoading } = useContext(AppContext);
  const { account } = useContext(AccountContext);

  usePageView('Home');

  const addSite = () => {
    navigate('/widget-creator');
  };

  const menuList = [
    {
      content: t('Manage Account'),
      icon: <Gear size={24} />,
      action: () => {
        navigate('/app-settings');
      }
    }
  ];

  useEffect(() => {
    if (!widgets.length) {
      setIsLoading(true);
      loadWidgets()
        .catch(err => {
          notification.warning(err.message);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, []);

  return (
    <div className="bootstrap-app-styles">
      <TopBar>{t('Home')}</TopBar>
      <SettingsPanel>
        {isEmbeded() ? (
          ''
        ) : (
          <div className="mb-4">
            <div className="d-flex">
              <h5 className="fw-bold mb-3 pe-2">{t('Account')}</h5>
              <span></span>
            </div>
            <NavList>{menuList}</NavList>
          </div>
        )}
        <div>
          <Row>
            <Col className="d-flex">
              <h5 className="fw-bold mb-3 pe-2">{t('Widgets')}</h5>
              {account.limits?.widgets?.maxWidgets && widgets.length ? (
                <div>
                  {widgets.length}
                  <span>/</span>
                  {account.limits?.widgets?.maxWidgets}
                </div>
              ) : (
                ''
              )}
            </Col>
          </Row>
          {!widgets ? (
            <Loader />
          ) : (
            <Row>
              <Col xs={12} className={widgets.length && 'mb-3'}>
                <Button variant="primary" size="lg" className={'w-100'} onClick={addSite}>
                  {!isDemo ? t('Add New Widget') : t('Select Widget')}
                </Button>
              </Col>
              {widgets &&
                widgets.length > 0 &&
                widgets.map(widget => {
                  if (
                    isEmbeded() &&
                    contextWidget.app &&
                    widget.app.name !== contextWidget.app.name
                  )
                    return;
                  return (
                    <UserWidget
                      key={widget.id}
                      widget={widget}
                      active={(activeWidget && activeWidget.id) === widget.id}
                    />
                  );
                })}
            </Row>
          )}
        </div>
      </SettingsPanel>
    </div>
  );
};

export default Home;
